import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Animated typewriter effect for chat session titles.
 * Only animates when the title changes to a new value.
 */
const AnimatedSessionTitle = ({ title, isActive }) => {
  const [displayed, setDisplayed] = useState(title);
  const [animating, setAnimating] = useState(false);
  const prevTitleRef = useRef(title);
  const timeoutIdRef = useRef();

  useEffect(() => {
    if (title !== prevTitleRef.current) {
      setAnimating(true);
      setDisplayed('');
      let i = 0;
      const reveal = () => {
        setDisplayed(title.slice(0, i + 1));
        i++;
        if (i < title.length) {
          timeoutIdRef.current = setTimeout(reveal, 18 + Math.random() * 32); // 18–50ms per letter
        } else {
          setAnimating(false);
          prevTitleRef.current = title;
        }
      };
      reveal();
      return () => clearTimeout(timeoutIdRef.current);
    } else {
      setDisplayed(title);
      setAnimating(false);
    }
  }, [title]);

  // Only render the animated title text, no cursor or extra symbols
  return (
    <span
      className={`transition-colors duration-200 ${isActive ? 'text-fg' : 'text-fg-muted'}`}
      style={{ fontFamily: 'inherit', letterSpacing: '0.01em' }}
    >
      {displayed}
    </span>
  );
};

AnimatedSessionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
};

export default AnimatedSessionTitle;
